import { render, staticRenderFns } from "./TopicoPlayers.vue?vue&type=template&id=1e888100&"
import script from "./TopicoPlayers.vue?vue&type=script&lang=js&"
export * from "./TopicoPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports